import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Tooltip ,Button } from 'reactstrap';
import moment from 'moment';
import { INPROGRESS, NEEDS_UPDATE } from '../../constants';
import { hasETACrossed } from './helper';
import { DATE_FORMAT } from '../../../../constants';
import { goolgeAnalyticsEvents } from '../../../../components/GoogleAnalytics/index';
import * as PortfolioConstants from '../../constants';
import BuyForm from '../../../search-result/View/BuyForm/index';
import DatabaseReportForm from '../../../search-result/DatabaseReportBuyForm/index';
import SubscriptionReportBuy from '../../../search-result/SubscriptionReportBuy/index';
import OtherReportBuyForm from '../../../search-result/OtherReportBuyForm/index';
import KycBuyForm from '../../../search-result/View/KycBuyForm/index';
import { GLOBAL_SEARCH_RESULT_BUY, REGEX1, REGEX2, REGEX3 } from '../../../search-result/constant';
import { MODAL_TYPE_FORM } from '../../../../../src/constants';
import * as createCaseActions from '../../../../Analyst/Cases/Create/actions' ;
import { connect } from 'react-redux';
import * as corporateAction from '../../../../Corporate/corporate/action';
import Modal from '../../../../components/UI/Modal/Modal';
import { Preloading } from '../../../../components/UI/Preloader/action';

class PortfolioTable extends Component {
    constructor() {
        super();
        this.state = {
            selectedItem:null,
            showModal:false,
            selectedCounterPartyList: [],
            selectedComputedReportId: null,
            showBuyButtons: false,
            selectedProductCategory:null,
            resizeZIndex: false,
        }
    }
    handleCheckboxChange = (selectedValue) => {
        let tempSelectedValue = [...this.state.selectedCounterPartyList]
        tempSelectedValue.push(selectedValue)
        this.setState({
            selectedCounterPartyList: tempSelectedValue
        })
    }
    toggle = (targetName) => {
        if (!this.state[targetName]) {
            this.setState({
                ...this.state,
                [targetName]: {
                    tooltipOpen: true
                }
            });
        } else {
            this.setState({
                ...this.state,
                [targetName]: {
                    tooltipOpen: !this.state[targetName].tooltipOpen
                }
            });
        }
    };
    isToolTipOpen = (targetName) => {
        return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
    };
    handleCompanyNameClick = (event, selCompanyName) => {
        goolgeAnalyticsEvents('Corporate', 'View Report Deatils', 'Report Details', '');
        this.props.selectedCounterPartyName(selCompanyName);
    }
    handleToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal
        }))
    }

    setProductCategory= () => {
        if(this.props.selectedCounterParty.country === "India"){
            let cinNumber=this.props.selectedCounterParty.cinNo
            let gstNumber=this.props.selectedCounterParty.gstNo
            let panNumber=this.props.selectedCounterParty.panNo

        if((cinNumber && cinNumber!=="Not Applicable/Available" && cinNumber!=="Not Available" && cinNumber!=="Not Applicable") ||
        (gstNumber && gstNumber.charAt(5)==='C')||
        (panNumber && panNumber.charAt(3)==='C') ) {
            this.setState({selectedProductCategory:"CORPORATE"});
            return "CORPORATE";
            }
            else{
                this.setState({selectedProductCategory:"NON_CORPORATE"});
                return "NON_CORPORATE";
            }
        }else{
            this.setState({selectedProductCategory:"INTERNATIONAL"});
            return "INTERNATIONAL";
        }
    }

    handleResizeZIndex = (resizeZIndexState) => {
        this.setState({
            resizeZIndex: resizeZIndexState
    })
    }

    handleInvestigationReport = (result) => {
        this.handleToggle();
        let temp=this.props.portfolioData.filter(itm=>itm.computedReportId===this.props.selectedComputedReportId)[0]
        let selectedProductCategory = this.setProductCategory();
        this.setState({
            body: <div>
                <BuyForm toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory || selectedProductCategory} selectedvalue={temp.counterpartyType} zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={'PORTFOLIO_BUY'} selectedCounterParty={temp} handleResizeZIndex={this.handleResizeZIndex} />
            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy report for - ' + this.props.selectedCounterParty.counterpartyName,
            modalCloseHandler: this.handleToggle,
        })
    }

    handleSubscriptionReport =(result) => {
        this.handleToggle();
        let selectedProductCategory = this.setProductCategory();
        let temp=this.props.portfolioData.filter(itm=>itm.computedReportId===this.props.selectedComputedReportId)[0]
        this.setState({
            body : <div>
                  <SubscriptionReportBuy toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory || selectedProductCategory} selectedvalue={temp.counterpartyType} zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={'PORTFOLIO_BUY'} selectedCounterParty={temp} handleResizeZIndex={this.handleResizeZIndex} propshistory={this.props.history}/>

            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy report for subscription report - ' + this.props.selectedCounterParty.counterpartyName,
            modalCloseHandler: this.handleToggle, 
        })

        
    }

    handleDatabaseBuy = (result) => {
        this.handleToggle();
        let selectedProductCategory = this.setProductCategory();
        let temp=this.props.portfolioData.filter(itm=>itm.computedReportId===this.props.selectedComputedReportId)[0]
        this.setState({
            body: <div>
                 <DatabaseReportForm toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory || selectedProductCategory} selectedvalue={temp.counterpartyType} zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={'PORTFOLIO_BUY'} selectedCounterParty={temp} handleResizeZIndex={this.handleResizeZIndex} propshistory={this.props.history}/>
            </div>,
             modalType: MODAL_TYPE_FORM,
             modalTitle: 'Buy report for databse report - ' + this.props.selectedCounterParty.counterpartyName,
             modalCloseHandler: this.handleToggle,
        })

    }

    handleOtherReport =(result) =>{
        this.handleToggle();
        let selectedProductCategory = this.setProductCategory();
        let temp=this.props.portfolioData.filter(itm=>itm.computedReportId===this.props.selectedComputedReportId)[0]
        this.setState({
            body : <div>
                  <OtherReportBuyForm toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory || selectedProductCategory} selectedvalue={temp.counterpartyType} zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={'PORTFOLIO_BUY'} selectedCounterParty={temp} handleResizeZIndex={this.handleResizeZIndex}/>

            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy report for other report - ' + this.props.selectedCounterParty.counterpartyName,
            modalCloseHandler: this.handleToggle, 
        })

    }

    render() {
        return (
            
            this.props.portfolioData.map(p => {
                let actionCheck,
                    lastUpdateDateCheck,
                    counterpartyNameTitle,
                    deliveryDate,
                    statusLabel,
                    statusText,
                    tooltipFlag,
                    identifiers;
                if (p.status[0] !== INPROGRESS) {
                    actionCheck = <Link onClick={(event)=>this.handleCompanyNameClick(event,p.counterpartyName)} id={`tooltip-${p.id}`} className="d-inline-block" to={`/credit-worthiness/${p.counterpartyId}/${p.counterpartyType}/${p.id}`}>{p.counterpartyName}</Link>
                    deliveryDate = <span><i className="icon-check icon-check-size"></i> &nbsp;{moment(p.deliveryDate).format(DATE_FORMAT)} </span>
                    counterpartyNameTitle = p.counterpartyName;
                    statusLabel = null;
                    statusText = p.status;
                } else {
                    actionCheck = <span id={`tooltip-${p.id}`}>{p.counterpartyName}</span>
                    counterpartyNameTitle = actionCheck
                    deliveryDate = <span className={hasETACrossed(p.deliveryDate) === 1 ? "orange-text" : hasETACrossed(p.deliveryDate) === 2 ? "red_text" : "green_text"} title={moment(p.deliveryDate).format(DATE_FORMAT)}><i className="icon-in-progress"></i> &nbsp;{moment(p.deliveryDate).format(DATE_FORMAT)}</span>
                    statusLabel = <span className="d-sm-none font-size-small">Status : </span>
                    if (p.status[0] === NEEDS_UPDATE) {
                        statusText = "NEEDS UPDATE";
                    } else if (p.status[0] === INPROGRESS) {
                        statusText = "IN PROGRESS";
                    }
                }
                identifiers=   <div>
                {p.panNo ? "PAN : " + p.panNo : null}
                {p.gstNo && p.panNo ? <br /> : null }
                {p.gstNo ? "GST : " + p.gstNo : null}
                { (p.panNo || p.gstNo) && p.cinNumber ? <br /> : null}
                {p.cinNumber ? "CIN : " + p.cinNumber : null}
                
              </div>

                tooltipFlag = this.isToolTipOpen(`tooltip-${p.id}`);
                if (p.lastUpdateDate) {
                    lastUpdateDateCheck = moment(p.lastUpdateDate).format(DATE_FORMAT)
                } else {
                    lastUpdateDateCheck = '-'
                }
                return (
                    <div key={p.id}>
                        <Modal show={this.state.showModal} className={this.state.resizeZIndex ? "z-index-zero Large-Modal" : "Large-Modal"} modalClosed={this.handleToggle} >
                    {this.state.body}
                </Modal>
                    <Row key={p.id} noGutters className={this.props.showBuyButtons ? "bg-light p-3 p-sm-0 mb-3 mb-sm-0" : "bg-light border-bottom p-3 p-sm-0 mb-3 mb-sm-0"}>
                        <Col xs="2" sm="1" className="custom-table-col p-sm-3">
                            <div className="custom-control custom-checkbox">
                                <input type="checkbox" onClick={this.props.handleCheckChildElement} checked={p.isChecked} onChange={e => {}} value={p.id} name={'report' + p.id} id={'report' + p.id} className="custom-control-input m-0" />
                                <label style={{ '--primaryColor': this.props.corporateColor.colorHexCode }} className="custom-control-label" htmlFor={'report' + p.id}>&nbsp;</label>
                            </div>
                        </Col>
                        <Col xs="22" sm="23" className="px-2">
                            <Row noGutters className="pl-3 pl-sm-0 company-portfolio">
                                <Col xs="24" sm={this.props.reportCategory !== PortfolioConstants.INVESTIGATED ? "6":"3"} className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0">
                                    <span className="d-sm-none font-family-bold">Company Name : </span>{actionCheck}
                                </Col>
                                <Col xs="24" sm="3" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Counterparty Type : </span>{p.counterpartyType}</Col>
                                <Col xs="24" sm="4" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Identifiers : </span>{identifiers}</Col>
                                {   this.props.reportCategory === PortfolioConstants.INVESTIGATED && 
                                    <Col xs="24" sm="2" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0 text-sm-center">
                                    <Col sm="6"><span className="d-sm-none font-family-bold">
                                        Rubix Risk Score :
                                        </span>{(p.riskScore) ? Number(p.riskScore).toFixed(1) : '-'}
                                    </Col>
                                    <Col sm="18" className={p.riskScoreTrend}></Col></Col>
                                }
                                {   this.props.reportCategory === PortfolioConstants.INVESTIGATED &&
                                    <Col xs="24" sm="3" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0 text-sm-center">
                                        <span className="d-sm-none font-family-bold mr-3">
                                            Risk Level</span>
                                            <span className={p.riskLevel}></span></Col>
                                }
                                <Col xs="24" sm={this.props.withoutRiskScore ? "5":"3"} className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Report Type : </span>{p.productName}&nbsp;<span className="d-sm-none">Report</span></Col>
                                <Col xs="24" sm="4" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0 text-truncate"><span className="d-sm-none font-family-bold">Delivery Date : </span>{deliveryDate}</Col>
                                <Col xs="24" sm="2" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0">
                                    {/* <Button outline color="primary">Buy</Button> */}
                                    {statusLabel}{statusText}
                                </Col>
                            </Row>
                        </Col>
                        <Tooltip style={{ textAlign: 'left' }} placement="right" isOpen={tooltipFlag} target={`tooltip-${p.id}`} toggle={() => this.toggle(`tooltip-${p.id}`)}>
                            <div>
                                {p.counterpartyName}
                            </div>
                            <div>
                                GST No: {p.gstNo}
                            </div>
                            <div>
                                PAN No: {p.panNo}
                            </div>
                        </Tooltip>
                    </Row>
                    
                    <Row>
                        <Col>
                        {this.props.selectedComputedReportId === p.computedReportId &&  this.props.showBuyButtons ?

                    <Row noGutters className="bg-light border-bottom p-3 p-sm-0 mb-3 mb-sm-0">
                    <Col className="d-flex justify-content-center mb-1">
                    <Row>
                    <Col>
                        <div className="btnBuy" role="group">
                            <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={p.counterpartyId} onClick={(e) => this.handleInvestigationReport(p)} ><i className="fa fa-shopping-cart mr-2"></i>Fresh Investigation </Button>
                            <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={p.counterpartyId} onClick={(e) => this.handleDatabaseBuy(p)}  hidden={(!p.lastDataDate || (!p.cinNumber || p.cinNumber === "")) && 'hidden'}><i className="fa fa-shopping-cart mr-2"></i> Rubix Database </Button>
                            <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={p.counterpartyId} onClick={(e) => this.handleSubscriptionReport(p) }  hidden={(p.cinNumber === '' || !p.cinNumber) || (!REGEX1.test(p.cinNumber) && !REGEX2.test(p.cinNumber) && !REGEX3.test(p.cinNumber)) && 'hidden'}><i className="fa fa-shopping-cart mr-2"></i>Business Profile (No Score) </Button>
                            <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={p.counterpartyId} onClick={(e) => this.handleOtherReport(p)}><i className="fa fa-shopping-cart mr-2"></i>Other Reports </Button>
                        </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
           :null}
        </Col>
    </Row>
</div>
)

})
)
}
}

 const  mapStateToProps = (state, ownProps) => ({
    selectedCounterParty: state.corporate.selectedCounterParty,
    userDetails: state.loginDetails.userDetails,
    result: state.createCase.result,
    counterpartyType: state.createCase.dropdownData
 })
 const mapDispatchToProps = (dispatch) => ({
    viewSelectedCounterparty: (counterpartyId) => { dispatch(corporateAction.viewSelectedCounterparty(counterpartyId)) },
    getProducts: (corporateId, type,selectedProductCategory,reportCategory) => { dispatch(createCaseActions.getProducts(corporateId, type,selectedProductCategory,reportCategory)) },
    getCounterpartyType: () => { dispatch(createCaseActions.getCounterpartyType()) },
    preloading: (status) => { dispatch(Preloading(status)) }
 })

 export default connect(mapStateToProps, mapDispatchToProps) (PortfolioTable);
